module.exports = __webpack_public_path__ + "img/field_4_highlighted.561eee6d.svg";